import React, { useState, useEffect, useCallback } from 'react';
import { Card, Form, ListGroup, Image } from 'react-bootstrap';
import MissingImage from '../../../../assets/merlin/missing_image.png';
import * as fuzz from 'fuzzball';
import useFuzzyProducts from 'hooks/useFuzzyProducts.js';
import { debounce } from 'lodash';

const MicroSearchBox = ({ setSelectedProduct }) => {

  const [fuzzyChoices, loading, error] = useFuzzyProducts();
  const [searchTerm, setSearchTerm] = useState('');
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState('');
  const [searchResults, setSearchResults] = useState([]);

  const debouncedSearch = useCallback(
      debounce((term) => {
          setDebouncedSearchTerm(term);
      }, 350),
      []
  );

  function handleSearchChange(e) {
      const value = e.target.value;
      setSearchTerm(value);
      debouncedSearch(value);
  }

  useEffect(() => {
      return () => {
          debouncedSearch.cancel();
      };
  }, [debouncedSearch]);

  function addToCurrentCart(product) {
    setSelectedProduct(product);
  }

  useEffect(() => {
      if (loading) return;
      if (!debouncedSearchTerm) {
          setSearchResults([]);
          return;
      }
      const options = {
          scorer: fuzz.partial_ratio,
          processor: (choice) => choice.proc_sorted,
          limit: 50,
          cutoff: 90,
          unsorted: false,
          full_process: true,
      };
      try {
          const results = fuzz.extract(debouncedSearchTerm, fuzzyChoices, options);
          setSearchResults(results);
      } catch (error) {
          console.log(error);
      }
  }, [debouncedSearchTerm, loading, fuzzyChoices]);

  return (
  <Card className='mb-3'>
    <Card.Body>
    <Form className='mb-1'>
        <Form.Control
            type="search"
            placeholder="Search for products..."
            aria-label="Search"
            className="rounded-pill search-input"
            value={searchTerm}
            onChange={handleSearchChange}  
        />
    </Form>
            {searchTerm.length > 0 ?
                    <div className='mb-4'>
                        <ListGroup>
                            {searchResults.map((hit, index) => {
                                const product = hit[0];
                                return (
                                    <ListGroup.Item
                                        key={index}
                                        className='d-flex justify-content-between align-items-center m-0'
                                        onClick={() => addToCurrentCart(product)}
                                    >
                                        <div className='d-flex align-items-center'>
                                            <Image 
                                                src={product?.image || MissingImage} 
                                                alt={product?.name} 
                                                height={50}
                                                />
                                            <div className='ms-2'>
                                                <p className='mb-0'>{product?.name}</p>
                                                <p className='mb-0'>SKU: {product?.sku}</p>
                                            </div>
                                        </div>
                                        <div>
                                            <p className='mb-0'>${hit.ibmi_cost}</p>
                                        </div>
                                    </ListGroup.Item>
                                )
                            })}
                        </ListGroup>
                    </div>
                :
                    null
            }
    </Card.Body>
    </Card>
  )
}

export default MicroSearchBox;